import React from 'react';
import { Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ChatIcon from '@mui/icons-material/Chat';
import PersonIcon from '@mui/icons-material/Person';
import { COLORS } from './styles';

function BottomNav({ active, onHome, onMessages, onProfile, unreadMessages = 0 }) {
  return (
    <Box sx={{
      borderTop: `1px solid ${COLORS.divider}`,
      backgroundColor: '#000',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      height: 44,
      flexShrink: 0,
    }}>
      <NavItem icon={<HomeIcon sx={{ fontSize: 22 }} />} active={active === 'home'} onClick={onHome} />
      <NavItem icon={<ChatIcon sx={{ fontSize: 20 }} />} active={active === 'messages'} onClick={onMessages} badge={unreadMessages} />
      <NavItem icon={<PersonIcon sx={{ fontSize: 22 }} />} active={active === 'profile'} onClick={onProfile} />
    </Box>
  );
}

function NavItem({ icon, active, onClick, badge }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        flex: 1,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: active ? COLORS.accent : COLORS.textMuted,
        position: 'relative',
        '&:active': { opacity: 0.7 },
      }}
    >
      {icon}
      {badge > 0 && (
        <Box sx={{
          position: 'absolute',
          top: 6,
          right: 'calc(50% - 18px)',
          minWidth: 16,
          height: 16,
          px: 0.5,
          borderRadius: '50%',
          backgroundColor: COLORS.danger,
          color: '#fff',
          fontSize: '0.55rem',
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          {badge}
        </Box>
      )}
    </Box>
  );
}

export default BottomNav;
